module.exports = __webpack_public_path__ + "static/media/leftmsgarrow.9669f53a.webp";